import './TaskDrawer.style.less'

import { Avatar, Space, List } from 'antd'

import { HistoryOutlined, UserOutlined } from '@ant-design/icons'

import { Title } from '@/components/Typography'

import { orderBy } from 'lodash'
import { ACTIVITY_LOG_TYPE } from '@/screens/Order/constant/activity_type'
import { Capitalize, OrdinalSuffix, isEmptyValue } from '@/utils/common'
import moment from 'moment'
import cx from 'classnames'
import { convertUtcToLocalDisplay } from '../TaskTable.transform'

function IsSameDate(start, end) {
  return convertUtcToLocalDisplay(start) === convertUtcToLocalDisplay(end)
}

function RenderStatus({ data }: any) {
  const { json_value, created_by } = data
  const { status, previous_status, submit_round, actual_date, activity_type } =
    json_value
  const { first_name, last_name } = created_by
  return (
    <p style={{ marginBottom: 0 }}>
      <span className="name-bold">
        {' '}
        {first_name} {last_name}
      </span>{' '}
      {activity_type == ACTIVITY_LOG_TYPE.SET_TASK_STATUS ? 'set' : 'updated'}
      <span
        className={cx(
          'name-bold',
          previous_status == 'approved' ? 'text-success' : '',
          previous_status == 'rejected' ? 'text-danger' : ''
        )}
      >
        {' '}
        {parseInt(previous_status)
          ? parseInt(previous_status) + '%'
          : Capitalize(previous_status)}{' '}
      </span>{' '}
      to{' '}
      <span
        className={cx(
          'name-bold',
          status == 'approved' ? 'text-success' : '',
          status == 'rejected' ? 'text-danger' : ''
        )}
      >
        {' '}
        {parseInt(status) ? parseInt(status) + '%' : Capitalize(status)}{' '}
      </span>{' '}
      {status == 'submitted'
        ? submit_round > 0
          ? `(${OrdinalSuffix(submit_round + 1)} time)`
          : ''
        : ''}{' '}
      on{' '}
      <span className="name-bold">{convertUtcToLocalDisplay(actual_date)}</span>
    </p>
  )
}

function RenderPlanDate({ data }: any) {
  const { json_value, created_by } = data
  const {
    activity_type,
    previous_plan_end_date,
    previous_plan_start_date,
    plan_start_date,
    plan_end_date,
  } = json_value
  const { first_name, last_name } = created_by
  return (
    <p style={{ marginBottom: 0 }}>
      <span className="name-bold">
        {' '}
        {first_name} {last_name}
      </span>{' '}
      {activity_type == ACTIVITY_LOG_TYPE.SET_TASK_PLAN_DATE
        ? 'set'
        : 'updated'}{' '}
      <span className="name-bold">Planned Date</span>{' '}
      {activity_type == ACTIVITY_LOG_TYPE.SET_TASK_PLAN_DATE ? 'to' : 'from'}{' '}
      {!isEmptyValue(previous_plan_start_date) && (
        <span className="name-bold">
          {convertUtcToLocalDisplay(previous_plan_start_date)}{' '}
          {!IsSameDate(previous_plan_start_date, previous_plan_end_date)
            ? '-' + convertUtcToLocalDisplay(previous_plan_end_date)
            : ''}{' '}
        </span>
      )}
      {activity_type == ACTIVITY_LOG_TYPE.UPDATE_TASK_PLAN_DATE ? 'to ' : ''}
      <span className="name-bold">
        {convertUtcToLocalDisplay(plan_start_date)}
        {!IsSameDate(plan_start_date, plan_end_date)
          ? ' -' + convertUtcToLocalDisplay(plan_end_date)
          : ''}
      </span>
    </p>
  )
}

function RenderAssignee({ data }: any) {
  const { json_value, created_by } = data
  const { activity_type, previous_assignee, assignee } = json_value
  const { first_name, last_name } = created_by
  return (
    <p style={{ marginBottom: 0 }}>
      <span className="name-bold">
        {' '}
        {first_name} {last_name}
      </span>{' '}
      {activity_type == ACTIVITY_LOG_TYPE.SET_TASK_ASSIGNEE ? 'set' : 'updated'}{' '}
      <span className="name-bold">Assignee</span>{' '}
      {activity_type == ACTIVITY_LOG_TYPE.SET_TASK_ASSIGNEE ? ' to' : 'from '}
      <span className="name-bold">
        {!isEmptyValue(previous_assignee) &&
          previous_assignee?.first_name +
            ' ' +
            previous_assignee?.last_name}{' '}
      </span>
      {!isEmptyValue(previous_assignee) && 'to '}
      <span className="name-bold">
        {assignee?.first_name + ' ' + assignee?.last_name}
      </span>
    </p>
  )
}

function HistoryLine(props: any) {
  const { created_by, json_value } = props.item

  const title =
    json_value.activity_type === ACTIVITY_LOG_TYPE.SET_TASK_PLAN_DATE ||
    json_value.activity_type === ACTIVITY_LOG_TYPE.UPDATE_TASK_PLAN_DATE ? (
      <RenderPlanDate data={props.item} />
    ) : json_value.activity_type === ACTIVITY_LOG_TYPE.SET_TASK_ASSIGNEE ||
      json_value.activity_type === ACTIVITY_LOG_TYPE.UPDATE_TASK_ASSIGNEE ? (
      <RenderAssignee data={props.item} />
    ) : (
      <RenderStatus data={props.item} />
    )

  return (
    <Space size="small" align="start">
      <Avatar
        size={'small'}
        icon={<UserOutlined />}
        src={created_by?.avatar?.url_path}
      />
      <div>
        <p className="comment">
          {title}
          <span className="date">
            {moment(props.item.created_date).format('DD MMM gggg')}
          </span>
        </p>
      </div>
    </Space>
  )
}

function History(props: any) {
  const { history } = props
  return (
    <div className="history-container">
      <Title level={5} className="title">
        <HistoryOutlined /> History
      </Title>
      <div className="list-container">
        {history?.length > 0 && (
          <List
            itemLayout="horizontal"
            dataSource={orderBy(history, ['created_date'], ['desc'])}
            renderItem={(value) => <HistoryLine item={value} />}
          />
        )}
      </div>
    </div>
  )
}

export default History
